export const GET_BUILDINGS_REPORT_PATH = '/buildings';
export const GET_SELECTED_INVENTORIES_REPORT_PATH = '/selectedInventories';
export const GET_INVENTORIES_LIST_CSV = '/inventoryList/listCsv';
export const GET_PDF_FORMAT = '/PDF';
export const GET_EXCEL_FORMAT = '/EXCEL';
export const GET_CSV_FORMAT = '/CSV';

export const GET_REPORT = 'GET_REPORT';
export const GET_REPORT_SUCCESS = `${GET_REPORT}/SUCCESS`;
export const GET_REPORT_FAILURE = `${GET_REPORT}/FAILURE`;

export const GET_CSV_REPORT = 'GET_CSV_REPORT';
export const GET_CSV_REPORT_SUCCESS = `${GET_CSV_REPORT}/SUCCESS`;
export const GET_CSV_REPORT_FAILURE = `${GET_CSV_REPORT}/FAILURE`;

export enum FileType {
  PDF = "Pdf",
  EXCEL = "Excel",
  CSV = "Csv"
}

export default {
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAILURE,
  GET_CSV_REPORT,
  GET_CSV_REPORT_SUCCESS,
  GET_CSV_REPORT_FAILURE,
  GET_INVENTORIES_LIST_CSV
};
